import { useRef } from "react";
import { EmptyActivityCard } from "views/components/Schedules/styles";
import UpdateActivityDialog from "views/components/Schedules/components/UpdateActivityPopup";
import FormManualReservationData from "./FormManualReservationData/FormManualReservationData";
import useUpdateActivityPopup from "views/components/Schedules/components/UpdateActivityPopup/hooks/useUpdateActivityPopup";

const ScheduleFreeActivity = ({
    activityColor,
    reloadData,
    quantityCells = 4,
    data: {
        resourceType, resourceId, date
    }
}) => {
    const $activity = useRef();
    const updateActivityPopup = useUpdateActivityPopup({
        $activity
    });
    const getClassName = () => {
        const classList = [
            "empty-activity", 
            "clickeable", 
            activityColor
        ];
        return classList.join(" ");
    }
    return (
        <td rowSpan={quantityCells}>
            <UpdateActivityDialog updateActivityPopup={updateActivityPopup}>
                <FormManualReservationData 
                    reloadData={reloadData}
                    showUpdateDialog={updateActivityPopup.popup.value}
                    resourceType={resourceType}
                    resourceId={resourceId}
                    date={date}/>
            </UpdateActivityDialog>
            <EmptyActivityCard 
                ref={$activity} 
                className={getClassName()}
                heightRatio={quantityCells}
                onClick={updateActivityPopup.popup.open}/>
        </td>
    );
}

export default ScheduleFreeActivity;